import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { fetchStitchingReturnlist, fetchStitchReturnGrpStid } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectKajeEmplist, selectKajeMemoNo, selectPressEmplist, selectStitchReGrpStId, selectStitchReturn, selectStitchReturnMemo } from '../Selectors/StitchSelector/StitchingSelectors';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { KjPrIssInwMenu } from '../TitleList';
import { fetchKajeEmplist, fetchKajeMemoNo, fetchStitchReturnMemo, kajeEntry, kajePressIssueInward } from '../../Store/PHPSlice/Kaje/KajeApi';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
import { fetchPressEmplist } from '../../Store/PHPSlice/Press/PressingApi';

const KjPrIssueInw = () => {

    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        sreId: '',
        sreMemo: '',
        kpMemo: '',
        depart: '',
        item: '',
        itemId: '',
        empNm: '',
        mcloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        totQty: '',
        instructions: '',
        userId: '1',
    });
    const [errors, setErrors] = useState({});
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [itemData, setItemData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [balQtyValues, setBalQtyValues] = useState(Array(itemData?.length).fill('0'));
    const [issueQtyValues, setIssueQtyValues] = useState(Array(itemData?.length).fill('0'));
    const actionMap = {
        master: fetchStitchingReturnlist,
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const departlist = useSelector(selectDaparement);
    const returnMemo = useSelector(selectStitchReturnMemo);
    const kjemplist = useSelector(selectKajeEmplist);
    const sreMemoNo = useSelector(selectKajeMemoNo);
    const stReturndata = useSelector(selectStitchReGrpStId);
    const premplist = useSelector(selectPressEmplist);
    useEffect(() => {
        dispatch(fetchDepartmentData());
        dispatch(fetchKajeMemoNo());
        dispatch(fetchStitchReturnMemo());
        dispatch(fetchKajeEmplist());
        dispatch(fetchPressEmplist());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (sreMemoNo.data) {
            const item = sreMemoNo.data.kajeNo;
            setFormData(prev => ({
                ...prev,
                kpMemo: item
            }))
        }
    }, [sreMemoNo]);



    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const filteredDepart = departlist.data.length > 0 ? departlist.data.filter(item => item.departNm === 'PRESSING' || item.departNm === 'KAJE') : [];

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'sreId':
                if (value) {
                    dispatch(fetchStitchReturnGrpStid(value));
                }
                break;
            default:
                break;
        }
    };

    console.log(stReturndata);
    const handleAddTable = () => {
        const data = stReturndata.data.length > 0 ? stReturndata.data[0] : [];
        const remain_qty = formData.depart === 'KAJE' ? data.kQty : data.pQty;
        const prev_qty = parseInt(data.totQty) - parseInt(remain_qty);
        // take k_sts = 1 if kaje else p_sts = 1  pressing
        const k_sts = formData.depart === 'KAJE' ? 1 : 0;
        const p_sts = formData.depart === 'PRESSING' ? 1 : 0;
        const departId = filteredDepart.find(item => item.departNm === formData.depart)?.ID;


        setItemData([
            ...itemData,
            {
                sreMemo: data.reMemo,
                itemId: data.itemId,
                itemNm: data.itemNm,
                mcloth: data.mcloth,
                m1cloth: data.m1cloth,
                m2cloth: data.m2cloth,
                m3cloth: data.m3cloth,
                mclothNm: data.mclothNm,
                m1clothNm: data.m1clothNm,
                m2clothNm: data.m2clothNm,
                m3clothNm: data.m3clothNm,
                soId: data.soId,
                actqty: data.totQty,
                prevqty: remain_qty === '0' ? remain_qty : prev_qty,
                remainqty: prev_qty > 0 ? prev_qty : remain_qty,
                issueqty: 0,
                returnqty: 0,
                balqty: 0,
                k_sts: k_sts,
                p_sts: p_sts,
                departId: departId,
                stId: formData.sreId,
                empId: formData.empNm,
                dt: formData.dt,
                kpMemo: formData.kpMemo,
                userId: formData.userId
            }
        ]);
        setFormData(prev => ({
            ...prev,
            sreId: '',
            empNm: ''
        }))
    };

    // Handle checkbox toggle
    const handleSelectRow = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter(i => i !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    // Handle delete selected rows
    const handleDeleteSelected = () => {
        const updatedData = itemData.filter((_, index) => !selectedRows.includes(index));
        setItemData(updatedData);
        setSelectedRows([]); // Clear selected rows after deletion
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleIssueQtyChange = (index, value) => {
        // Allow only numeric values
        if (/^\d*$/.test(value)) {
            const newData = [...itemData];
            const issueQty = Math.min(value, newData[index].remainqty); // Ensure issueQty is not greater than remainqty
            newData[index].issueqty = issueQty;
            newData[index].returnqty = issueQty; // Set return qty to the same as issue qty
            newData[index].balqty = newData[index].remainqty - issueQty; // Calculate balance qty
            setItemData(newData);
        }
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };


    const validate = () => {
        const newErrors = {};
        if (!formData.firm) newErrors.firm = 'firm is required';
        if (!formData.challanNo) newErrors.challanNo = 'challanNo is required';
        if (!formData.sono) newErrors.sono = 'Sale Order No is required';
        if (!formData.category) newErrors.category = 'category is required';
        if (!formData.empNm) newErrors.empNm = 'empNm is required';
        if (!formData.totMtr) newErrors.totMtr = 'totMtr is required';
        return newErrors;
    };

    function convertIntoOneObject(itemData, formData) {
        const data = {
            itemData: itemData,
            userId: formData.userId,
            dt: formData.dt,
        };
        return data;
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        const finalObject = convertIntoOneObject(itemData, formData);

        dispatch(kajePressIssueInward(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                toast.success("Kaje Press Added");
                window.location.reload();
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };

    return (
        <>
            <TitleBar data={KjPrIssInwMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Kaje - Press(Iron) Issue/Inward Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'K-P Memo', name: 'kpMemo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="depart">Department:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="depart"
                                                    name="depart"
                                                    options={filteredDepart}
                                                    getOptionLabel={(option) => option.departNm || ''}
                                                    value={filteredDepart.find(item => item.departNm === formData.depart) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'depart', value: newValue ? newValue.departNm : '' } }, 'depart')}
                                                    // onOpen={() => handleDropdownOpen('reMemo')}
                                                    // onClose={() => handleDropdownClose('reMemo')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            // label="Select an option"
                                                            variant="outlined"
                                                            placeholder='Select an option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option.departNm === value.departNm}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {formData.depart !== 'PRESSING' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="sreId">Stitching Return No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="sreId"
                                                        name="sreId"
                                                        options={Array.isArray(returnMemo?.kstMemo)
                                                            ? returnMemo.kstMemo
                                                            : []
                                                        }
                                                        getOptionLabel={(option) => option.reMemo || ''}
                                                        value={returnMemo?.kstMemo?.find(item => item.stId === formData.sreId) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'sreId', value: newValue ? newValue.stId : '' } }, 'sreId')}
                                                        // onOpen={() => handleDropdownOpen('sreId')}
                                                        // onClose={() => handleDropdownClose('sreId')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                // label="Select an option"
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.stId === value.stId}
                                                        disabled={formData.depart === ''}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.depart === 'PRESSING' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="sreId">Stitching Return No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="sreId"
                                                        name="sreId"
                                                        options={Array.isArray(returnMemo?.pstMemo)
                                                            ? returnMemo.pstMemo
                                                            : []
                                                        }
                                                        getOptionLabel={(option) => option.reMemo || ''}
                                                        value={returnMemo?.pstMemo?.find(item => item.stId === formData.sreId) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'sreId', value: newValue ? newValue.stId : '' } }, 'sreId')}
                                                        // onOpen={() => handleDropdownOpen('sreId')}
                                                        // onClose={() => handleDropdownClose('sreId')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                // label="Select an option"
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.stId === value.stId}
                                                        disabled={formData.depart === ''}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.depart !== 'PRESSING' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="empNm">Master Name:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="empNm"
                                                        name="empNm"
                                                        options={kjemplist?.data}
                                                        getOptionLabel={(option) => option.empNm || ''}
                                                        value={kjemplist?.data?.find(item => item.ID === formData.empNm) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'empNm', value: newValue ? newValue.ID : '' } }, 'empNm')}
                                                        onOpen={() => handleDropdownOpen('empNm')}
                                                        onClose={() => handleDropdownClose('empNm')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                // label="Select an option"
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                        disabled={formData.sreId === ''}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                                {formData.depart === 'PRESSING' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="empNm">Master Name:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="empNm"
                                                        name="empNm"
                                                        options={premplist?.data}
                                                        getOptionLabel={(option) => option.empNm || ''}
                                                        value={premplist?.data?.find(item => item.ID === formData.empNm) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'empNm', value: newValue ? newValue.ID : '' } }, 'empNm')}
                                                        onOpen={() => handleDropdownOpen('empNm')}
                                                        onClose={() => handleDropdownClose('empNm')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                // label="Select an option"
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                        disabled={formData.depart === ''}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleAddTable} disabled={formData.empNm === ''} style={{ marginRight: '2%' }}>Add</Button>
                                    <Button variant="contained" color="secondary" onClick={handleDeleteSelected} disabled={selectedRows.length === 0}>
                                        Delete
                                    </Button>
                                </Grid>

                                {itemData.length > 0 &&
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableBody>

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Select</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Stitching Inw.No.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '25vw' }} align='center' className='tbl-row'>Item</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Act. Qty.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Prev. Issue Qty.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Remain Qty.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Return Qty.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Bal Qty.</TableCell>
                                                </TableRow>
                                                {
                                                    itemData.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                                                                <Checkbox
                                                                    checked={selectedRows.includes(index)}
                                                                    onChange={() => handleSelectRow(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.sreMemo}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{`${item.itemNm}- 
                                                                ${item.mcloth !== '0' ? item.mclothNm : ' '},${item.m1cloth !== '0' ? item.m1clothNm : ' '},
                                                                ${item.m2cloth !== '0' ? item.m2clothNm : ' '},${item.m3cloth !== '0' ? item.m3clothNm : ' '}`}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.actqty}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.prevqty}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.remainqty}</TableCell>
                                                            {/* Issue Qty input */}
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <input
                                                                    type="text"
                                                                    value={item.issueqty || ''}
                                                                    onChange={(e) => handleIssueQtyChange(index, Number(e.target.value))}
                                                                    min="0"
                                                                    max={item.remainqty} // Set max limit to remain qty
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>

                                                            {/* Return Qty (read-only, same as Issue Qty) */}
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.returnqty || 0}</TableCell>

                                                            {/* Bal Qty (remainqty - issue qty) */}
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.balqty || 0}</TableCell>
                                                        </TableRow>
                                                    ))
                                                }

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default KjPrIssueInw;
